import { HttpParams, httpResource } from '@angular/common/http';
import { computed, runInInjectionContext } from '@angular/core';
import { widgetHttpHeader } from 'scw-digital-boards-widgets';
import { oeeContext } from '../../../../core/interceptors/api-interceptor.interceptor';
import { IGetManyResponse } from '../../../../utilities/http-utilities.service';
import { AdvancedFilterApiMatcher } from './advanced-filter-api-matcher';

export interface IShiftDetails {
  id: number;
  name: string;
  siteIds: string;
  lineIds: string;
}

export class ShiftAdvancedFilterApiMatcher extends AdvancedFilterApiMatcher {
  private readonly lineId = computed(() => this.inUseApiFilters()['lineId']);
  public override idValidationResource = runInInjectionContext(this.injector, () =>
    httpResource<IGetManyResponse<IShiftDetails>>(() => {
      return {
        context: oeeContext,
        headers: widgetHttpHeader,
        method: 'GET',
        reportProgress: true,
        url: 'scheduler/shifts/shift-details',
        ...(!this.lineId() ? {} : { params: new HttpParams().set('lineIds', `[${this.lineId()}]`) }),
      };
    }),
  );

  public override label = computed(() => {
    return this.idValidationResource.status() === 'resolved'
      ? (this.idValidationResource.value()?.data.find(({ id }) => id === this.id)?.name ?? '...')
      : '...';
  });

  public override validateDependencies(): boolean {
    return Boolean(this.idValidationResource.value()?.data.length);
  }
}
